import { Component, OnInit } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { AuthorizationService } from '../services/authorization.service';

@Component({
    selector: 'legendary-custom',
    template: require('./legendary-custom.component.html'),
    styles: [require('../styles/legendary.css')]
})
export class LegendaryCustomComponent {
    isLoggedIn: boolean = false;

    constructor(private http: Http, private auth: AuthorizationService) { }

    ngOnInit() {
        this.isLoggedIn = this.auth.isLoggedIn();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Apps/legendary/custom/legendary-custom.component.ts